import { render, staticRenderFns } from "./BookingFeeOptionFields.vue?vue&type=template&id=c524b2e8&scoped=true&"
import script from "./BookingFeeOptionFields.vue?vue&type=script&lang=js&"
export * from "./BookingFeeOptionFields.vue?vue&type=script&lang=js&"
import style0 from "./BookingFeeOptionFields.vue?vue&type=style&index=0&id=c524b2e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c524b2e8",
  null
  
)

export default component.exports